import Em from 'ember';

export default Em.Component.extend({
  didInsertElement() {
    this._super(...arguments);
    this.get('inserterApi.createBlock')('paragraph', {
      text: 'Bam! Insta-text! Plus - another below 😱',
      align: 'left',
    });
    this.get('inserterApi.createBlock')('paragraph', {
      text: 'Pow!',
      align: 'left',
    });
  },
});
